import dateFormat from "date-format";
const Advertising = () =>
	import(
		/* webpackChunkName: "component-advertising" */ "@/components/advertising"
	);
import Header from "@/components/template-components/header";
const Footer = () =>
	import(
		/* webpackChunkName: "component-footer" */ "@/components/template-components/footer"
	);
const SmartBanner = () =>
	import(
		/* webpackChunkName: "component-smart-banner" */ "@/components/smart-banner"
	);
import { PAGES, LANG_EN, AD_LAYOUT_STUBS } from "@/common/consts";
import { mapGetters } from "vuex";

import { created, mounted, destroyed } from "./hooks";

/**
 * MAIN APP
 *
 * This App Component provides the basic layout page for all WF. That's a
 * `router-view` with a common top Leaderboard Banner, the Header, the Footer,
 * and the Smart Banner.
 *
 * TODO: ./styles.scss aren't scoped and they SHOULD provide proper page layouts
 * (something like .page.full-width, page.with-sidebar; or alike) and also
 * generic Heading styles to be consistently used across components.
 */
export default {
	name: "App",
	data() {
		return {
			AD_LAYOUT_STUBS,
			headerHeight: null,
			windowHeight: null,
			windowWidth: null,
			smartBannerVisible: true,
		};
	},
	computed: {
		...mapGetters(["getCurrentPage", "isDialogOpen"]),
		classNames() {
			let c = [];

			if (this.showSmartBanner) {
				c.push("smart-banner-visible");
			}

			if (this.$store.getters.getCurrentPage == PAGES.NOT_FOUND) {
				c.push("page-not-found");
			}

			return c;
		},
		showLeaderboardAd() {
			return this.isMediumDeviceOrWider;
		},
		showAdhesionAd() {
			if (
				this.windowHeight !== null &&
				this.windowHeight < 500 &&
				this.isSmallDevice
			) {
				return false;
			}

			return this.isSmallDevice;
		},
		isHomeOrLandingPages() {
			switch (this.$route.name) {
				case PAGES.HOME:
				case PAGES.SCRABBLE_DICT:
				case PAGES.WWF:
				case PAGES.FOURPICS:
				case PAGES.ANAGRAM:
				case PAGES.WORD_MAKER:
				case PAGES.JUMBLE_SOLVER:
				case PAGES.WORD_UNSCRAMBLER:
				case PAGES.UNSCRAMBLE:
				case PAGES.LETTERS_AND_BLANK:
				case PAGES.WORD_CHUMS_CHEAT:
				case PAGES.WORDBRAIN_ANSWERS:
				case PAGES.WORDCOOKIES:
				case PAGES.WORDFEUD:
				case PAGES.WORD_DESCRAMBLER:
				case PAGES.WORDSCAPES:
				case PAGES.SCRABBLE_CHECKER:
				case PAGES.TEXT_TWIST:
				case PAGES.CODY_CROSS:
				case PAGES.WORD_SWIPE_CHEATS:
				case PAGES.WORD_STORY:
				case PAGES.WORD_CONNECT:
					return true;
				default:
					return false;
			}
		},
		isResultsPage() {
			switch (this.$route.name) {
				case PAGES.FOURPICS_RESULTS:
				case PAGES.SCRABBLE_DICT_RESULTS:
				case PAGES.SCRABBLE_EXACTMATCH_RESULTS:
				case PAGES.UNSCRAMBLER_RESULTS:
				case PAGES.UNSCRAMBLER_RESULTS_REMEMBER:
				case PAGES.WORDS_BY_LENGTH_RESULTS:
				case PAGES.WORDS_CONSONANTS:
				case PAGES.WORDS_ENDING_ING:
				case PAGES.WORDS_ENDING_RESULTS:
				case PAGES.WORDS_HAVING_RESULTS:
				case PAGES.WORDS_STARTING_RESULTS:
				case PAGES.WORDS_VOWELS:
				case PAGES.WORDS_WITH_Q_NO_U:
					return true;
				default:
					return false;
			}
		},
		showSmartBanner() {
			return false; // On 20200618 we disabled the smart banner. This is most likely temporary.
			// return this.isSmallOrMediumDevice && this.smartBannerVisible && this.currentLanguage === LANG_EN && this.isHomeOrLandingPages;
		},
	},
	components: {
		Advertising,
		Header,
		Footer,
		SmartBanner,
	},
	methods: {
		onWindowResize() {
			this.windowHeight =
				window.innerHeight ||
				document.documentElement.clientHeight ||
				document.body.clientHeight;
			this.windowWidth =
				window.innerWidth ||
				document.documentElement.clientWidth ||
				document.body.clientWidth;
			this.$store.commit("updateWindowProperties", {
				windowHeight: this.windowHeight,
				windowWidth: this.windowWidth,
			});
		},
		onWindowScroll() {
			this.$store.commit("updateWindowScroll", window.pageYOffset);
		},
		checkLastVisited() {
			const lastVisitedTime = window.$cookies.get("last_visited");
			this.$store.commit("updateLastVisited", lastVisitedTime);
			this.setLastVisited();
		},
		setLastVisited() {
			const currentTime = dateFormat(
				dateFormat.ISO8601_WITH_TZ_OFFSET_FORMAT
			);
			window.$cookies.set("last_visited", currentTime, "7d");
		},
		detectAdBlocker() {
			//Detect adblocker scripts.
			if (
				typeof window.__PRERENDER_INJECTED === "undefined" &&
				typeof window.__TEST__ === "undefined"
			) {
				var test = document.createElement("div");
				test.innerHTML = "&nbsp;";
				test.className = "adsbox";
				document.body.appendChild(test);
				window.setTimeout(() => {
					if (test.offsetHeight === 0) {
						this.$el.classList.add("is-blocking-ads");
					}
					test.remove();
				}, 100);
			} else if (typeof window.__TEST__ !== "undefined") {
				// In testing mode we always want it to adblock.
				this.$el.classList.add("is-blocking-ads");
			}
		},
	},
	mounted,
	created,
	destroyed,
};
